if (!window.attachDrawerSwipeClose) {
  const SWIPE_CLOSE_MIN_DISTANCE = 80;
  const SWIPE_CLOSE_FLICK_MIN_DISTANCE = 30;
  const SWIPE_CLOSE_FLICK_MIN_VELOCITY = 0.5;
  const SWIPE_IGNORE_SELECTOR = '.swiper, [data-swipe-ignore]';

  /**
   * @param {HTMLElement} element - the drawer panel that receives the gesture
   * @param {{ position?: 'right' | 'left' | 'bottom' | (() => 'right' | 'left' | 'bottom'), onClose: () => void }} options
   *   `position` may be a function, read at the end of each swipe, for drawers whose edge changes with the breakpoint
   * @returns {() => void} detach
   */
  window.attachDrawerSwipeClose = (element, { position = 'right', onClose }) => {
    let startX;
    let startY;
    let startTime;

    const handleTouchStart = (event) => {
      if (event.target.closest(SWIPE_IGNORE_SELECTOR)) {
        startX = undefined;
        return;
      }

      const touch = event.touches[0];
      startX = touch.clientX;
      startY = touch.clientY;
      startTime = event.timeStamp;
    };

    const handleTouchEnd = (event) => {
      if (startX === undefined) return;

      const touch = event.changedTouches[0];
      const deltaX = touch.clientX - startX;
      const deltaY = touch.clientY - startY;
      const elapsed = event.timeStamp - startTime;
      startX = undefined;

      const edge = typeof position === 'function' ? position() : position;
      const isVertical = edge === 'bottom';
      const primary = isVertical ? deltaY : deltaX;
      const cross = isVertical ? deltaX : deltaY;
      const direction = edge === 'left' ? -1 : 1;
      const distanceTowardEdge = primary * direction;
      const velocity = elapsed > 0 ? distanceTowardEdge / elapsed : Infinity;

      const isDominantAxis = Math.abs(primary) > Math.abs(cross);
      const isPastDistance = distanceTowardEdge > SWIPE_CLOSE_MIN_DISTANCE;
      const isFlick =
        distanceTowardEdge > SWIPE_CLOSE_FLICK_MIN_DISTANCE &&
        velocity > SWIPE_CLOSE_FLICK_MIN_VELOCITY;

      if (isDominantAxis && (isPastDistance || isFlick)) {
        onClose();
      }
    };

    element.addEventListener('touchstart', handleTouchStart, { passive: true });
    element.addEventListener('touchend', handleTouchEnd, { passive: true });

    return () => {
      element.removeEventListener('touchstart', handleTouchStart);
      element.removeEventListener('touchend', handleTouchEnd);
    };
  };
}
